module.exports = __webpack_public_path__ + "img/egypt.70247bdc.svg";